module.exports = __webpack_public_path__ + "img/icon-brench.fb2d9991.svg";